import React from 'react';
import { Spin } from 'antd';

export default function Loader({ zIndex = 10000, tip = 'Loading...' }) {
  const style = {
    position: 'absolute',
    zIndex,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  };

  return (
    <Spin style={style} tip={tip} size="large" />
  );
}



// WEBPACK FOOTER //
// ./src/components/Loader/index.js